import { MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';
// import { withStyles } from '@material-ui/core/styles';
// import InputBase from '@material-ui/core/InputBase';

// const BootstrapInput = withStyles((theme) => ({
//     root: {
//         'label + &': {
//             marginTop: theme.spacing(3),
//         },
//     },
//     input: {
//         borderRadius: 4,
//         position: 'relative',
//         backgroundColor: theme.palette.background.paper,
//         border: '1px solid #ced4da',
//         fontSize: 16,
//         padding: '8px 26px 9px 12px',
//         transition: theme.transitions.create(['border-color', 'box-shadow']),
//         // Use the system font instead of the default Roboto font.
//         fontFamily: [
//             '-apple-system',
//             'BlinkMacSystemFont',
//             '"Segoe UI"',
//             'Roboto',
//             '"Helvetica Neue"',
//             'Arial',
//             'sans-serif',
//             '"Apple Color Emoji"',
//             '"Segoe UI Emoji"',
//             '"Segoe UI Symbol"',
//         ].join(','),
//         '&:focus': {
//             borderRadius: 4,
//             borderColor: '#80bdff',
//             boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
//         },
//     },
// }))(InputBase);

const SLayout = styled.div``;

const PageSize = ({ onChange = (pageSize) => null, value = 10, label, isLoading }) => {
    return (
        <SLayout style={{ minWidth: label ? 80 : 40}}>
            <FormControl variant='outlined' fullWidth size={'small'} disabled={isLoading}>
                {label && <InputLabel id="demo-customized-select-label">{label}</InputLabel>}
                <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    value={value}
                    label={label}
                    onChange={(e) => {
                        onChange(e.target.value);
                    }}
                    // input={<BootstrapInput />}
                >
                    <MenuItem value="" disabled>
                        <em>Select a page size</em>
                    </MenuItem>
                    {/* <MenuItem value={5}>5</MenuItem> */}
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                </Select>
            </FormControl>
        </SLayout>
    );
};

export default PageSize;
